import { render, staticRenderFns } from "./UpdatePieceModal.vue?vue&type=template&id=5c2bbbdd&"
import script from "./UpdatePieceModal.vue?vue&type=script&lang=js&"
export * from "./UpdatePieceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports